import { Children, useState, useEffect } from "react";

function SummarySection({ title, alignment, required, children }) {
  // handle small screens with react inline styles
  const mediaMatch = window.matchMedia("(max-width: 500px");
  const [matches, setMatches] = useState(mediaMatch.matches);

  useEffect(() => {
    const handler = (e) => setMatches(e.matches);
    mediaMatch.addEventListener("change", handler);
    return () => mediaMatch.removeEventListener("change", handler);
  }, [matches]); // eslint-disable-line react-hooks/exhaustive-deps
  let kids = Children.toArray(children);

  let oddKids = kids.filter((kid, index) => index % 2 === 1);
  let evenKids = kids.filter((kid, index) => index % 2 === 0);

  const Styles = {
    summarySectionLeft: {
      display: "flex",
      flexDirection: "column",
      width: matches ? "95vw" : "12rem",
      marginRight: matches ? 0 : "2rem",
      marginBottom: matches ? "1rem" : 0,
      alignItems: "left",
    },
    summarySectionRight: {
      display: "flex",
      flexDirection: "column",
      width: matches ? "90vw" : "12rem",
      marginRight: matches ? 0 : "2rem",
      marginBottom: matches ? "1rem" : 0,
    },
    summarySectionWhole: {
      display: "flex",
      flexDirection: "column",
      width: matches ? "90vw" : "28rem",
    },
    summarySectionCenter: {
      display: "flex",
      flexDirection: "column",
      width: matches ? "90vw" : "12rem",
      marginRight: "1rem",
      marginLeft: "1rem",
      marginBottom: matches ? "1rem" : 0,
    },
    summaryChildren: {
      flexDirection: "column",
      width: "100%",
    },
    groupContainer: {
      display: "flex",
      flexDirection: matches ? "column" : "row",
      justifyContent: matches ? "flex-start" : "center",
      alignItems: matches ? "left" : "center",
    },
    child: {
      width: matches ? "90%" : "100%",
      display: "flex",
      flexDirection: "column",
    },
    leftChild: {
      width: matches ? "90%" : "100%",
      display: "flex",
      flexDirection: "column",
      paddingRight: "2rem",
    },
    title: {
      fontSize: "0.9rem",
      fontWeight: "bold",
      marginBottom: "0.3rem",
    },
    center: {
      display: "flex",
      margin: matches ? "0 auto 0.7rem 0" : "0 auto 0.7rem auto",
    },
    hr: {
      width: matches ? "100%" : "80vw",
      marginBottom: "1rem",
      backgroundColor: "lightgrey",
    },
    row: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
    },
  };

  let style;
  if (alignment === "left") {
    style = Styles.summarySectionLeft;
  } else if (alignment === "right") {
    style = Styles.summarySectionRight;
  } else if (alignment === "whole") {
    style = Styles.summarySectionWhole;
  } else if (alignment === "center") {
    style = Styles.summarySectionCenter;
  }

  return (
    <div style={style}>
      {matches && alignment === "right" && <hr style={Styles.hr} />}
      {alignment === "whole" ? (
        <>
          {/* Puts each group of 2 children side by side then the next 2 underneath the first, side by side, etc. */}
          <div style={Styles.center}>
            <span
              className={required ? "required-field-before" : ""}
              style={Styles.title}
            >
              {title}
            </span>
          </div>
          {matches ? (
            <div style={Styles.child}>{kids}</div>
          ) : (
            <div style={Styles.row}>
              <div style={Styles.leftChild}>{evenKids}</div>
              <div style={Styles.child}>{oddKids}</div>
            </div>
          )}
        </>
      ) : (
        <>
          <p
            className={required ? "required-field-before" : ""}
            style={Styles.title}
          >
            {title}
          </p>
          <div style={Styles.summaryChildren}>{children}</div>
        </>
      )}
    </div>
  );
}

export default SummarySection;
